module.exports = {
  messages: {
    CN: {
      "newsList.title": "标题",
      "newsList.category": "分类",
      "newsList.status": "状态",
      "newsList.publishTime": "发布日期",
      "newsList.lastEditPerson": "最后修改人",
      "newsList.lastEditTime": "最后修改时间",
      "newsList.enable": "已发布",
      "newsList.disabled": "未发布",
      "newsList.action": "操作",
      "newsList.edit": "编辑",
      "newsList.publish": "发布",
      "newsList.publishTip": "是否发布",
      "newsList.unPublish": "取消发布",
      "newsList.unPublishTip": "是否取消发布",
      "newsList.delete": "删除",
      "newsList.deleteTip": "是否删除",
      "newsList.confirmTop": "置顶",
      "newsList.cancelTop": "取消置顶",
      "newsDetail.basicInfo": "基本信息",
      "newsDetail.titleError": "请输入情报标题",
      "newsDetail.categoryError": "请选择情报分类",
      "newsDetail.contentType": "内容类型",
      "newsDetail.link": "链接",
      "newsDetail.text": "富文本",
      "newsDetail.content": "情报内容",
      "newsDetail.contentError": "请输入情报内容",
      "newsDetail.categoryModal": "情报分类管理",
      "newsDetail.categoryName": "名称",
      "newsDetail.newsNum": "所属情报数量",
      "newsDetail.categoryNameError": "请输入情报分类名称",
      "newsDetail.linkContent": "链接内容",
      "newsDetail.linkError": "请输入链接内容",
      "newsDetail.productInfo": "相关商品",
      "newsDetail.inventoryquantity": "在库数"
    },
    JP: {
      "newsList.title": "タイトル",
      "newsList.category": "カテゴリ",
      "newsList.status": "状態",
      "newsList.publishTime": "公開日",
      "newsList.lastEditPerson": "最終更新者",
      "newsList.lastEditTime": "最終更新日時",
      "newsList.enable": "公開済み",
      "newsList.disabled": "未公開",
      "newsList.action": "操作",
      "newsList.edit": "編集",
      "newsList.publish": "公開",
      "newsList.publishTip": "公開しますか",
      "newsList.unPublish": "公開を取り消す",
      "newsList.unPublishTip": "公開を取り消しますか？",
      "newsList.delete": "削除",
      "newsList.deleteTip": "削除しますか",
      "newsList.confirmTop": "トップに固定",
      "newsList.cancelTop": "固定解除",
      "newsDetail.basicInfo": "基本情報",
      "newsDetail.titleError": "情報タイトルを入力してください",
      "newsDetail.categoryError": "情報カテゴリを選択してください",
      "newsDetail.contentType": "コンテンツタイプ",
      "newsDetail.link": "リンク",
      "newsDetail.text": "リッチテキスト",
      "newsDetail.content": "情報内容",
      "newsDetail.contentError": "情報内容を入力してください",
      "newsDetail.categoryModal": "情報カテゴリ管理",
      "newsDetail.categoryName": "名称",
      "newsDetail.newsNum": "所属情報の数量",
      "newsDetail.categoryNameError": "情報カテゴリの名称を入力してください",
      "newsDetail.linkContent": "リンク内容",
      "newsDetail.linkError": "リンク内容を入力してください",
      "newsDetail.productInfo": "関連商品",
      "newsDetail.inventoryquantity": "在庫数"
    }
  }
};